/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetAnswersDto } from './AssetAnswersDto';
import {
    AssetAnswersDtoFromJSON,
    AssetAnswersDtoFromJSONTyped,
    AssetAnswersDtoToJSON,
    AssetAnswersDtoToJSONTyped,
} from './AssetAnswersDto';
import type { AssetFinancialHoldingRequest } from './AssetFinancialHoldingRequest';
import {
    AssetFinancialHoldingRequestFromJSON,
    AssetFinancialHoldingRequestFromJSONTyped,
    AssetFinancialHoldingRequestToJSON,
    AssetFinancialHoldingRequestToJSONTyped,
} from './AssetFinancialHoldingRequest';

/**
 * 
 * @export
 * @interface SaveAssetsRequest
 */
export interface SaveAssetsRequest {
    /**
     * 
     * @type {AssetAnswersDto}
     * @memberof SaveAssetsRequest
     */
    answers: AssetAnswersDto;
    /**
     * 
     * @type {Array<AssetFinancialHoldingRequest>}
     * @memberof SaveAssetsRequest
     */
    financialHoldings: Array<AssetFinancialHoldingRequest>;
}

/**
 * Check if a given object implements the SaveAssetsRequest interface.
 */
export function instanceOfSaveAssetsRequest(value: object): value is SaveAssetsRequest {
    if (!('answers' in value) || value['answers'] === undefined) return false;
    if (!('financialHoldings' in value) || value['financialHoldings'] === undefined) return false;
    return true;
}

export function SaveAssetsRequestFromJSON(json: any): SaveAssetsRequest {
    return SaveAssetsRequestFromJSONTyped(json, false);
}

export function SaveAssetsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveAssetsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'answers': AssetAnswersDtoFromJSON(json['answers']),
        'financialHoldings': ((json['financialHoldings'] as Array<any>).map(AssetFinancialHoldingRequestFromJSON)),
    };
}

export function SaveAssetsRequestToJSON(json: any): SaveAssetsRequest {
    return SaveAssetsRequestToJSONTyped(json, false);
}

export function SaveAssetsRequestToJSONTyped(value?: SaveAssetsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'answers': AssetAnswersDtoToJSON(value['answers']),
        'financialHoldings': ((value['financialHoldings'] as Array<any>).map(AssetFinancialHoldingRequestToJSON)),
    };
}

